import { BaseListModel } from "../base/base-list-model";
import { PaymentModel } from "./payment.model";

export const PaymentsListModel = BaseListModel(PaymentModel).named("Payments");
